import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PercentageCreateDto } from 'src/app/shared/dtos/percentage/percentageCreateDto';
import { PercentageUpdateDto } from 'src/app/shared/dtos/percentage/percentageUpdateDto';
import { PercentageDataType } from 'src/app/shared/enums/percentageDataType';
import { NumberFormatterPipe } from 'src/app/shared/pipes/number-formatter.pipe';
import { DefinationService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { PercentageService } from 'src/app/shared/services/percentage.service';

@Component({
  selector: 'app-percentage',
  templateUrl: './percentage.component.html',
  styleUrls: ['./percentage.component.scss'],
  providers:[NumberFormatterPipe]
})
export class PercentageComponent implements OnInit {
  constructor(
    private definationService: DefinationService,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private percentageService: PercentageService,
    private numberFormatterPipe: NumberFormatterPipe,
  ) {}

  defaultDataSource: any;
  specificDataSource: any;
  yearDataSource: any;
  kmDataSource: any;
  tramerDataSource: any;
  cityDataSource: any;
  percentageDataType = PercentageDataType;
  percentageCreateDto!: PercentageCreateDto;
  cities: any;
  brands: any;
  models:any
  modelsLookup:any
  selectedBrandId:any
  selectedModelId:any
  modelPercentageValue:any
  booleanType: any= [{id:true, name:"Evet"},{id:false, name:"Hayır"} ]
  searchModeOption:string = "contains";
  searchExprOption:string = "field";
  searchTimeoutOption = 200;
  minSearchLengthOption = 0;
  showDataBeforeSearchOption = false;

  ngOnInit(): void {
    this.getList();
    this.getLookup();
  }

  async getList() {
    var list = await firstValueFrom(this.percentageService.getList());
    this.defaultDataSource = list.filter((f: any) => f.dataType == PercentageDataType.Default);
    this.specificDataSource = list.filter((f: any) => f.dataType == PercentageDataType.Specific);
    this.yearDataSource = list.filter((f: any) => f.dataType == PercentageDataType.Year);
    this.kmDataSource = list.filter((f: any) => f.dataType == PercentageDataType.Km);
    this.tramerDataSource = list.filter((f: any) => f.dataType == PercentageDataType.Tramer);
    this.cityDataSource = list.filter((f: any) => f.dataType == PercentageDataType.City);
  }
  async getLookup() {
    var data = await firstValueFrom(this.percentageService.getLookup());
    this.cities = data.cities;
    this.brands = data.brands;
    this.modelsLookup = data.models
  }
  async create(event: any) {
   var createDto: PercentageCreateDto = {
      minYear: event.data.minYear,
      maxYear: event.data.maxYear,
      minKm: event.data.minKm,
      maxKm: event.data.maxKm,
      minTramer: event.data.minTramer,
      maxTramer: event.data.maxTramer,
      brandId: event.data.brandId,
      modelId: event.data.modelId,
      cityId: event.data.cityId,
      dataType: event.data.dataType,
      percentageValue: event.data.percentageValue,
      isActive: event.data.isActive,
      isDefault: event.data.isDefault,
      isDefaultYear: event.data.isDefaultYear,
      isDefaultKm: event.data.isDefaultKm,
      isDefaultTramar: event.data.isDefaultTramar,
      isDefaultCity: event.data.isDefaultCity,
    };

    if (!this.createformControl(createDto)){
      this.getList()
      return
    }

    let data = await firstValueFrom(this.percentageService.create(createDto));
    if(data.status == true)
      this.notificationService.show(data.message);
    
    if(data.status == false)
      this.notificationService.showError(data.message);
    this.getList()
  }
  async update(event: any) {
    var updateDto: PercentageUpdateDto = {
      id: event.oldData.id,
      minYear: event.newData.minYear ?? event.oldData.minYear,
      maxYear: event.newData.maxYear ?? event.oldData.maxYear,
      minKm: event.newData.minKm ?? event.oldData.minKm,
      maxKm: event.newData.maxKm ?? event.oldData.maxKm,
      minTramer: event.newData.minTramer ?? event.oldData.minTramer,
      maxTramer: event.newData.maxTramer ?? event.oldData.maxTramer,
      brandId: event.newData.brandId ?? event.oldData.brandId,
      modelId: event.newData.modelId ?? event.oldData.modelId,
      cityId: event.newData.cityId ?? event.oldData.cityId,
      dataType: event.oldData.dataType,
      percentageValue:event.newData.percentageValue ?? event.oldData.percentageValue,
      isActive: event.newData.isActive ?? event.oldData.isActive,
      isDefault: event.newData.isDefault ?? event.oldData.isDefault,
      isDefaultYear: event.newData.isDefaultYear ?? event.oldData.isDefaultYear,
      isDefaultKm: event.newData.isDefaultKm ?? event.oldData.isDefaultKm,
      isDefaultTramar: event.newData.isDefaultTramar ?? event.oldData.isDefaultTramar,
      isDefaultCity: event.newData.isDefaultCity ?? event.oldData.isDefaultCity,
    };

    if (!this.updateformControl(updateDto)) {
      this.getList()
      return
    }

    let data =  await firstValueFrom(this.percentageService.update(updateDto.id, updateDto));
    if(data.status == true)
      this.notificationService.show(data.message);
    
    if(data.status == false)
      this.notificationService.showError(data.message);
    this.getList()
  }
  async delete(event:any){
    await firstValueFrom(this.percentageService.delete(event.data.id))
    this.notificationService.show('Başarı ile silindi');
    this.getList()
  }
  async saveSpecificModel(){
    if(!this.selectedBrandId){
      this.notificationService.showError("Marka seçmek zorunludur")
      return
    }
    var createDto: PercentageCreateDto = {
      brandId: this.selectedBrandId,
      modelId: this.selectedModelId,
      dataType: PercentageDataType.Specific,
      percentageValue: this.modelPercentageValue,
      isActive: true,
    };
    let data =  await firstValueFrom(this.percentageService.create(createDto));
    if(data.status == true){
      this.notificationService.show(data.message);
      this.selectedBrandId = null
      this.selectedModelId = null
    }
    
    if(data.status == false)
      this.notificationService.showError(data.message);
      
    this.getList()
  }
  async onBrandsChanged(event: any){
    this.models = await firstValueFrom(this.percentageService.getLookupModel(this.selectedBrandId))
  }
  onInitNewRow(event: any, type: PercentageDataType) {
    event.data.isActive = true;
    event.data.dataType = type;
  }
  createformControl(createDto: PercentageCreateDto): boolean {
    //yıl kontrol
    if (createDto.dataType == PercentageDataType.Year) {
      if ((createDto.minYear && createDto.minYear < 1950) || (createDto.maxYear && createDto.maxYear < 1950)) {
        this.notificationService.showError('1950 den küçük bir yıl girmeyiniz');
        return false;
      }
      var currentYear = new Date().getFullYear();
      if ((createDto.minYear && currentYear < createDto.minYear) || (createDto.maxYear && currentYear < createDto.maxYear)) {
        this.notificationService.showError('Yıl ileri tarihli olamaz');
        return false;
      }

      if(createDto.minYear && createDto.maxYear && createDto.maxYear < createDto.minYear){
        this.notificationService.showError('Minimum yıl, maksimum yıldan büyük olamaz');
        return false;
      }

    }

    //km kontrol
    if (createDto.dataType == PercentageDataType.Km) {
      if ((createDto.minKm && createDto.minKm < 0) || (createDto.maxKm && createDto.maxKm < 0)) {
        this.notificationService.showError('Kilometre negatif sayı olamaz');
        return false;
      }

      if(createDto.minKm && createDto.maxKm && createDto.maxKm < createDto.minKm){
        this.notificationService.showError('Minimum km, maksimum kmden büyük olamaz');
        return false;
      }
    }

    //tramer kontrol
    if (createDto.dataType == PercentageDataType.Tramer) {
      if ((createDto.minTramer && createDto.minTramer < 0) || (createDto.maxTramer && createDto.maxTramer < 0)) {
        this.notificationService.showError('Tramer negatif sayı olamaz');
        return false;
      }

      if(createDto.minTramer && createDto.maxTramer && createDto.maxTramer < createDto.minTramer){
        this.notificationService.showError('Minimum tramer, maksimum tramerden büyük olamaz');
        return false;
      }
    }
   
    //şehir kontrol
    if (createDto.dataType == PercentageDataType.City) {
      if(this.cityDataSource.find((f:any)=>f.cityId == createDto.cityId)){
        this.notificationService.showError('Daha önce tanımlama olan şehir için tekrar tanımlama yapılamaz');
        return false;
      }
    }

    return true;
  }
  updateformControl(updateDto: PercentageUpdateDto) {
    //yıl kontrol
    if (updateDto.dataType == PercentageDataType.Year || updateDto.dataType == PercentageDataType.Specific) {
      if ((updateDto.minYear && updateDto.minYear < 1950) || (updateDto.maxYear && updateDto.maxYear < 1950)) {
        this.notificationService.showError('1950 den küçük bir yıl girmeyiniz');
        return false;
      }

      var currentYear = new Date().getFullYear();
      if ((updateDto.minYear && currentYear < updateDto.minYear) || (updateDto.maxYear && currentYear < updateDto.maxYear)) {
        this.notificationService.showError('Yıl ileri tarihli olamaz');
        return false;
      }

      if(updateDto.maxYear && updateDto.minYear && updateDto.maxYear < updateDto.minYear){
        this.notificationService.showError('Minimum yıl, maksimum yıldan büyük olamaz');
        return false;
      }
    }

    //km kontrol
    if (updateDto.dataType == PercentageDataType.Km || updateDto.dataType == PercentageDataType.Specific) {
      if ((updateDto.minKm && updateDto.minKm < 0) || (updateDto.maxKm && updateDto.maxKm < 0)) {
        this.notificationService.showError('Kilometre negatif sayı olamaz');
        return false;
      }

      if(updateDto.minKm && updateDto.maxKm && updateDto.maxKm < updateDto.minKm){
        this.notificationService.showError('Minimum km, maksimum kmden büyük olamaz');
        return false;
      }
    }
    
    //tramer kontrol
    if (updateDto.dataType == PercentageDataType.Tramer || updateDto.dataType == PercentageDataType.Specific) {
      if ((updateDto.minTramer && updateDto.minTramer < 0) || (updateDto.maxTramer && updateDto.maxTramer < 0)) {
        this.notificationService.showError('Tramer negatif sayı olamaz');
        return false;
      }

      if(updateDto.minTramer && updateDto.maxTramer && updateDto.maxTramer < updateDto.minTramer){
        this.notificationService.showError('Minimum tramer, maksimum tramerden büyük olamaz');
        return false;
      }
    }
    
    //spesifik kontrol
    if(updateDto.dataType == PercentageDataType.Specific){
      if((updateDto.maxYear && !updateDto.minYear) || (!updateDto.maxYear && updateDto.minYear)){
         this.notificationService.showError('Yıl alanlarının ikiside boş veya ikiside dolu olmalıdır');
         return false;
      }
      if((updateDto.maxKm && !updateDto.minKm) || (!updateDto.maxKm && updateDto.minKm)){
         this.notificationService.showError('Km alanlarının ikiside boş veya ikiside dolu olmalıdır');
         return false;
      }
      if((updateDto.maxTramer && !updateDto.minTramer) || (!updateDto.maxTramer && updateDto.minTramer)){
         this.notificationService.showError('Tramer alanlarının ikiside boş veya ikiside dolu olmalıdır');
         return false;
      }

      if((updateDto.minYear || updateDto.maxYear) && (updateDto.isDefaultYear)){
        this.notificationService.showError('Yıl alanları dolu olduğu için default yıl oranları kullanılamaz');
        return false;
      }
      if((updateDto.minKm || updateDto.maxKm) && (updateDto.isDefaultKm)){
        this.notificationService.showError('Km alanları dolu olduğu için default km oranları kullanılamaz');
        return false;
      }
      if((updateDto.minTramer || updateDto.maxTramer) && (updateDto.isDefaultTramar)){
        this.notificationService.showError('Tramer alanları dolu olduğu için default tramer oranları kullanılamaz');
        return false;
      }
      if(updateDto.cityId && updateDto.isDefaultCity){
        this.notificationService.showError('Şehir alanı dolu olduğu için default şehir oranları kullanılamaz');
        return false;
      }
    }
    return true;
  }
  getNumberFormatter(number:any){
    return this.numberFormatterPipe.transformPercentage(number)
  }
}
